import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "gfu-heading gfu-heading--top-divider _mt-3 _mb-2" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_summary_list = _resolveComponent("base-summary-list")
  const _component_progress_overlay = _resolveComponent("progress-overlay")

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_base_summary_list, {
      "summary-list-data": $options.summaryListModel,
      class: "_mt-5"
    }, {
      header: _withCtx(() => [
        _createElementVNode("h2", _hoisted_1, _toDisplayString(_ctx.Resources.YourPledge.OrderSummaryHeader), 1 /* TEXT */)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["summary-list-data"]),
    _createVNode(_component_progress_overlay, {
      visible: !$options.hasOrderDetails
    }, null, 8 /* PROPS */, ["visible"])
  ]))
}